<template>
  <div class="lm-new-col"></div>
</template>

<script>
export default {
  name: "WorkspaceNewCol"
};
</script>

<style>
.lm-new-col {
  height: 150px;
  margin-left: 20px;
  margin-bottom: 15px;
  width: 45px;
  cursor: pointer;
  border: 1px dashed black;
}
</style>
